export default __webpack_public_path__ + "images/d9d0154e54ae16e4c135791189903743-emoji-peaceful.svg";